// import React from 'react'
import { getMessageStatus } from '../../Services/PropertyListService'

// let recordReady = false
let recordId = ''
let messageId = ''
let startTime, currentTime
const pollingTime = 60

function getTimeDifference() {
    currentTime = new Date()
    let dif = startTime.getTime() - currentTime.getTime()

    let Seconds_from_T1_to_T2 = dif / 1000
    return Math.abs(Seconds_from_T1_to_T2)
}

export async function pollMessageStatus(_messageId, onRecordReady, createAlert, successMessage, errorMessage) {
    startTime = new Date()
    messageId = _messageId
    recordId = ''

    if (!messageId) {
        onRecordReady('Invalid request !!', 'error')
        return false
    }

    // localStorage.setItem("messageId", messageId)
    localStorage.setItem('messageId', JSON.stringify({ value: messageId, timestamp: new Date() }))
    // onRecordReady('Please wait, your request is being processed.', 'warning')

    let continuePolling = true

    try {
        do {
            let response = await getMessageStatus(`messageId=${messageId}`)
            if (response && response.status === 200) {
                let message = response && response.data ? response.data.message : { 'status': '' }

                switch (message.status) {
                    case 'done':
                        localStorage.removeItem('propertyInfo');
                        localStorage.setItem("messageId", '')
                        continuePolling = false
                        recordId = response.data.message.recordId
                        onRecordReady(successMessage ? successMessage : createAlert(recordId), 'success')
                        break;
                    case 'permanently failed':
                        localStorage.setItem("messageId", '')
                        continuePolling = false
                        let responseMessage = 'Something went wrong !!'

                        if (message.errorMessages && Array.isArray(message.errorMessages)) {
                            let errMessage = await errorMessageConversion(message.errorMessages[0].message)
                            responseMessage = errMessage ? `Request failed: ${errMessage}` : responseMessage
                        }
                        // console.log(' message :: ', responseMessage)
                        onRecordReady(responseMessage, 'error')
                        localStorage.removeItem('propertyInfo');
                        break;
                    default:
                        await new Promise(resolve => setTimeout(resolve, 2500));
                        continuePolling = true
                        break;
                }

            } else {
                continuePolling = false
                onRecordReady('Something went wrong!! ', 'error')
            }

            if (continuePolling && getTimeDifference() > pollingTime) {
                continuePolling = false
                onRecordReady(errorMessage, 'error')
            }

        }
        while (continuePolling)

    } catch (error) {
        console.log(' error in pollMessageStatus :: ', error)
    }

    async function errorMessageConversion(errorMessageFrmServer) {
      if (errorMessageFrmServer.includes('insufficient access rights on cross-reference id')) {
        let ids = errorMessageFrmServer
          .replace('insufficient access rights on cross-reference id: ', '')
          .split(',')
        let propertyInfoCacheObj = localStorage.getItem('propertyInfo') ? JSON.parse(localStorage.getItem('propertyInfo')) : {}
        let propertyNames = []
        ids.forEach(id => {
          if (id) {
            propertyNames.push(propertyInfoCacheObj[id] ? propertyInfoCacheObj[id] : id)
          }
        })
        // let propertyName = propertyInfoCacheObj[id] ? propertyInfoCacheObj[id] : id;
        localStorage.removeItem('propertyInfo')
        return `Following Properties are no longer available in OmniView: ${propertyNames.join()}`
      }
      return errorMessageFrmServer
    }
}
